<template>
  <!-- 第一段新闻 -->
  <!-- 新闻标题 -->
  <Transition name="fade">
    <div v-if="newsItem.length" class="news-item">
      <h3>
        <RouterLink
          target="_blank"
          :title="newsTitle.neName"
          :to="`/news/newsdetail?clID=${clID}&id=${newsTitle._id}`"
        >
          {{ newsTitle.neName }}
        </RouterLink>
      </h3>
      <div class="items" v-for="item in newsItem" :key="item._id">
        <ul>
          <li>
            <RouterLink
              :title="item.neName"
              target="_blank"
              :to="`/news/newsdetail?clID=${clID}&id=${item._id}`"
              >{{ item.neName }}</RouterLink
            >
          </li>
        </ul>
      </div>
    </div>
    <NewsListSkeleton v-else />
  </Transition>
</template>

<script>
import NewsListSkeleton from "./news-list-skeleton.vue";
import { findRandomNews } from "@/api/news";
import { ref, onUnmounted } from "vue";
export default {
  components: {
    NewsListSkeleton,
  },
  setup() {
    const clID = ref([]);
    const newsItem = ref([]);
    const newsTitle = ref({});
    let intervalId = null;

    const randomclID = [
      3559, 3558, 1332, 1331, 1330, 1329, 375, 374, 1804, 342, 1803, 1951, 1328,
      1327, 1326, 1325, 2906, 2752, 2756, 2773, 2775, 2780, 8858, 227, 2776,
      2753, 2755, 1144, 2774, 2781, 8859, 2767, 226, 2777, 1158, 18329, 2758,
      1201, 1198, 1200, 1197, 1205, 1199, 1360, 1361, 2771, 2772, 2759, 2754,
      248, 2751, 2760, 2750, 2757, 2769, 2763, 2765, 282, 2768, 2766, 303, 225,
      2764, 1159, 18328, 1362, 2770, 1758, 1552, 1794, 1785, 1792, 1791, 1759,
      1757, 1796, 1783, 1784, 1763, 1550, 1795, 1790, 1788, 1793, 1760, 1798,
      1549, 1746, 1797, 1745, 1789, 1787, 1765, 1766, 1764, 1612, 1749, 1744,
      1551, 1613, 1743, 1756, 1614, 1753, 1752, 1754, 1755, 1762, 1782, 1750,
      1748, 1747, 1751, 8157, 1553, 1768, 1778, 1769, 1775, 1776, 1767, 1774,
      1773, 1779, 1772, 1777, 1761, 1780, 1259, 1092, 1094, 1246, 1245, 8186,
      121, 1815, 1053, 2844, 1055, 1057, 1056, 1248, 1825, 1083, 2845, 1050,
      1051, 87, 1249, 1824, 1819, 1818, 2837, 2838, 2839, 1251, 1261, 1095,
      1091, 1264, 1822, 1262, 1260, 2843, 2841, 73, 1813, 2830, 1419, 1093,
      1257, 1823, 1263, 1250, 2842, 2878, 63, 1141, 1256, 1265, 1244, 1821,
      1817, 1266, 2877, 2875, 1247, 71, 1255, 1142, 2904, 1812, 1816, 1418,
      1851, 110, 1164, 69, 1258, 105, 127, 1139, 1416, 1137, 1814, 2829, 2831,
      2835, 2840, 1252, 1820, 1849, 18905, 2833, 2828, 2834, 2836, 100, 1417,
      102, 1163, 1253, 126, 1847, 2880, 1848, 2881, 129, 116, 123, 119, 1846,
      2879, 3572, 3575, 3573, 2882, 1850, 1659, 1675, 1693, 1631, 1624, 1731,
      1829, 1710, 2863, 1712, 1714, 1713, 1661, 1839, 1709, 2864, 1716, 1717,
      1664, 1838, 1833, 1832, 2856, 2857, 2858, 1682, 1678, 1700, 1642, 1698,
      1836, 1685, 1673, 2862, 2860, 1646, 1827, 2849, 1725, 1617, 1680, 1639,
      1837, 1687, 1669, 2861, 2869, 1628, 1632, 1626, 1706, 1622, 1835, 1831,
      1721, 2868, 2866, 1636, 1643, 1620, 1671, 2905, 1826, 1830, 1707, 1691,
      1845, 2854, 1645, 1649, 2848, 1828, 1738, 1701, 1640, 1695, 2850, 1694,
      1719, 1834, 1843, 18906, 2852, 2847, 2853, 2855, 1690, 1683, 1666, 1696,
      1615, 1733, 1737, 1841, 2871, 1842, 2872, 1740, 1726, 1734, 1729, 1840,
      2870, 3570, 3574, 3571, 2873, 1844, 212, 167, 1799, 1800, 1801, 1192,
      3555, 1802, 3561, 3552, 3553, 3556, 3554, 3560, 3557,
    ];

    findRandomNews({ limit: 12 }).then((data) => {
      newsTitle.value = data[0];
      newsItem.value = data.slice(1, data.length - 1);
    });

    function getRandomNumber(arr) {
      const randomIndex = Math.floor(Math.random() * arr.length);
      return arr[randomIndex];
    }

    intervalId = setInterval(() => {
      clID.value = getRandomNumber(randomclID);
    }, 3000);

    onUnmounted(() => {
      // 清除定时器
      if (intervalId) {
        clearInterval(intervalId);
      }
    });

    return { newsItem, newsTitle, clID };
  },
};
</script>

<style lang="less" scoped>
.news-item {
  width: 700px;
  h3 {
    a {
      display: block;
      padding-top: 15px;
      padding-bottom: 15px;
      margin-left: 8px;
      color: #fd7400;
      outline: none;
      text-align: center;
      font-size: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .items {
    width: 100%;
    background: #f59e9e;
    ul {
      a {
        width: 100%;
        display: block;
        float: left;
        padding: 8px 5px 5px 8px;
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          color: @shColor;
        }
      }
    }
  }
}
</style>
